import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  className: "custom-toast",
  progressClassName: "custom-progress",
  pauseOnHover: false,
  pauseOnFocusLoss: false,
};

export const successToast = (message) => toast.success(message, toastOptions);
export const errorToast = (message) => toast.error(message);
